/* Add CustomFields Sep 23, 2023 */
/* Add kt-notes,d_savedRecord Feb 17, 2024 */
/* Add m_processVoice June 1, 2024 */
/* Add p_mode to custom-field Aug 24, 2024 */
/* Add  read only columns Jan 25, 2025 */
/* Remove Notes May 30, 2025 */
/* Add Competitor Bids Tab April 11, 2026 */
/* GUI Changes Phase 1 May 15, 2026  */ 
<template lang="pug">
	<b-tabs>	
	<b-tab title="Competitor">
	<keep-alive>
	div
		rec-wrap(:p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="cmpt" :p_isModal="p_isModal"
		:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_altView="d_altViewKey" @altViewChg="d_altViewKey = $event"   @focused="d_currentFocus = $event" @voice="m_processVoice") 
			template(v-slot:rec-form-header)
				div(class="d-flex raisedHeader")
					div(style="text-align:left;width:20%" )
						kt-photo(id="competitorPhoto" ref="kt-photo" p_prntRecKey="cmpt" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
					div(class="d-flex flex-column justify-content-center")
						<span class="d-block"><span style="color:#4fa4ff; font-size:25px;">{{d_recData.competitorName}}</span></span> 
			template(v-slot:rec-form-left)
				span <span style="color:#ff9333;">*</span>indicates field is required.
				div(class="form-group")
					label(class="required-label") Competitor #
					b-form-input(class="styled-input" id="competitorNo" size="sm"  v-model="d_recData.competitorNo" disabled placeholder="Auto Generated"  )
				div(class="form-group")
					label(class="required-label") Competitor Name
					b-form-input(class="styled-input" id="competitorName" size="sm"  v-model="d_recData.competitorName" required)
				div(class="form-group")
					label(:class="m_required('address')?'required-label':''") Address
					b-form-textarea(class="styled-input" id="address" size="sm"  v-model="d_recData.address" rows=3 no-resize )
			template(v-slot:rec-form-right)
				div(class="form-group")
					label Phone #s	
					kt-com-fld(id="phoneNo" :p_mode="p_mode" :p_readOnly="m_readOnly('phoneNo')" typ="p" v-model="d_recData.phoneNo" placeholder="Direct")
					kt-com-fld(id="officePhoneNo" :p_mode="p_mode" :p_readOnly="m_readOnly('officePhone')" typ="f" v-model="d_recData.officePhoneNo" placeholder="Office")
					kt-com-fld(id="mobilePhoneNo" :p_mode="p_mode" :p_readOnly="m_readOnly('mobilePhoneNo')" typ="pm" v-model="d_recData.mobilePhoneNo" placeholder="Mobile")
				div(class="form-group")
					label(:class="m_required('website')?'required-label':''") Website
					kt-com-fld(id="website" typ="w" :p_readOnly="m_readOnly('website')" v-model="d_recData.website")
				div(class="form-group")
					label Email
					kt-com-fld(id="email" :p_mode="p_mode" typ="@" :p_disabled="m_readOnly('email')" v-model="d_recData.email")
				div(class="form-group")
					b-form-checkbox(id="inactive" :value="true" v-model="d_recData.inactive") Inactive
			template(v-slot:rec-form-center)
				div(class="form-group")
					label(:class="m_required('competitorDetails')?'required-label':''") Competitor Details
					b-input-group-prepend(class="px-0")
						b-input-group-text
							fa-icon(icon="list-ul")
						b-form-textarea(class="styled-input" id="competitorDetails" size="sm" v-model="d_recData.competitorDetails" rows=5)
				kt-custom-field(v-if="d_customFields.length>0" :p_mode="p_mode" p_prntRecKey="cmpt" :p_recData="d_recData.customData"  @change="d_recData.customData=$event")
			template(v-slot:rec-alt-view)
				kt-related(v-if="d_altViewKey=='RR'" :p_relatedGrids="m_relatedGrids()" )
	</keep-alive>
	</b-tab>
	<b-tab title="🏷️ Opportunity Bids" style="text-align:left;">
	<keep-alive>
	
		<div style="width:60%; max-height:700px;overflow-y:auto">
			<b-table id="opportunityBids" 	:items="d_recData.opportunityBids" 	:fields="d_opportunityBidFields" show-empty :empty-html="c_tableEmpty" small responsive head-variant="light">
				<template #cell(opportunityName)="data" >
					<div>
						<router-link :to="m_linkPath(data.item.opportunityNo)" > {{data.item.opportunityName}}</router-link>
					</div>
				</template>
				<template #cell(bidAmount)="data" >
					<div>{{ m_fmtMoney(data.item.bidAmount) }}</div>
				</template>
			
			</b-table>
		</div>
				
	</keep-alive>
	</b-tab>
	</b-tabs>
</template>

<script>
import util,{fn_getHashId} from "@/utils/util.js";
import {fn_saveRecord} from "@/utils/api.js";
import RecWrap from "@/components/RecWrap.vue";
import KTRelated, {RelatedGridClass, getColFns} from "@/components/Ctrl/KT-Related.vue";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";
import {refData,userSettings} from "@/utils/ref-data.js";

export default {
	name: "cmpt-rec",
	components: {
		'rec-wrap': RecWrap,
		'kt-related': KTRelated,
		'kt-custom-field': KTCustomField,
	},
	created() {
		if (this.p_mode != 'create' && !this.p_recNo) {
			this.d_recNo = fn_getHashId(this);
		}
		else if (this.p_recNo) {
			this.d_recNo = this.p_recNo;
		}
		var usrOpts = userSettings.userOptions;
		if(usrOpts['tableReadOnlyColumns']) this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns']['kt-table-cmpt'];
		if(usrOpts['tableRequiredColumns']) this.d_requiredColumns=usrOpts['tableRequiredColumns']['kt-table-cmpt'];
		if(this.d_requiredColumns) this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});
	},
	mounted() {
		
		this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
	},
	data() {
		return {
			d_recNo: null,
			d_recData: {},
			d_altViewKey: null,
			d_savedRecord:null,
			d_customFields:refData.customFields.filter(c=>(c.context=='cmpt')),
			d_currentFocus:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
			d_opportunityBidFields: [
				{ label: "Opportunity Name", key: "opportunityName", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "Bid Amount", key: "bidAmount", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "Bid Position", key: "bidPosition", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				{ label: "Winning Bid", key: "winningBid", visible: true,thStyle:"border-top:none;border-bottom:none;border-right:0.1em solid #adb5bd;padding:0.1em;"},
				],
		};
	},
	provide() {
    return {vcrec: this}
	},
	props: {
		p_recNo: String,
		p_mode: String,
		p_isModal: Boolean,
	},
	computed: {
      c_tableEmpty() {return `<div style="color:#4fa4ff;text-align:left;">No Bids!</div>`;
    },
    c_tblMinWidth() {
      const visible = this.d_opportunityBidFields.filter(f => f.visible).length;
      return visible < 4 ? null : `${visible * 200}px`;
    },
 	c_recInfo() {
      let rd = this.d_recData;
      return {
        Id: rd.competitorId,
        No: rd.competitorNo,
        Name: rd.competitorName,
      };
    },
	c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: rd.photoURL,
				photoName: rd.photoName
			};
		},   
	},
	methods: {
		m_processVoice(e){	
			document.getElementById(this.d_currentFocus).value=e;
		},
		m_saveFn() { //Called from  RecWrap, KTList, KTSelect
			let id = this.p_mode == 'edit' ? this.d_recData.competitorId : null;
			//d_savedRecord:null;
			return fn_saveRecord('competitor', id, this.d_recData);
		},
		m_relatedGrids() {
			let fC = {key: 'cmpt', label: 'Competitor', paramNm: 'competitorId'};

			let recId = this.d_recData.competitorId;
			let recNm = this.d_recData.competitorName;

			let rOppr = new RelatedGridClass('cmpt', recId, recNm, 'oppr', getColFns.oppr, [fC]);

			return [rOppr];
		},
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},		
		m_fmtMoney(val) {
			 return "$"+val.toLocaleString('en-US');
		},
		m_linkPath(recNo) {
			return {path: util.fn_hrefVwRec('oppr', recNo)};
		},
    },
watch: {},
  
};


</script>
<style scoped lang="less">
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    
  box-shadow: none;
}
.raisedHeader{
	position1:fixed;
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
	z-index1: 9;
	}
.raisedHeader img {
	border-radius: 8px;
}
.raisedHeader .d-flex {
  align-items: center;
}
.nav-link.active {
  color: #0f5132 !important;              /* deep green text */
  border-bottom-color: #8fd19e  !important; /* soft mint underline */
}
</style>